/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAccountRequest
 */
export interface UpdateAccountRequest {
    /**
     * 氏名
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    employeeName: string;
    /**
     * プロフィール画像パス
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    profileImagePath?: string;
    /**
     * SlackID
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    slackId?: string;
    /**
     * 電話番号 13桁
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    phoneNumber: string;
}

/**
 * Check if a given object implements the UpdateAccountRequest interface.
 */
export function instanceOfUpdateAccountRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "employeeName" in value;
    isInstance = isInstance && "phoneNumber" in value;

    return isInstance;
}

export function UpdateAccountRequestFromJSON(json: any): UpdateAccountRequest {
    return UpdateAccountRequestFromJSONTyped(json, false);
}

export function UpdateAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAccountRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'employeeName': json['employee_name'],
        'profileImagePath': !exists(json, 'profile_image_path') ? undefined : json['profile_image_path'],
        'slackId': !exists(json, 'slack_id') ? undefined : json['slack_id'],
        'phoneNumber': json['phone_number'],
    };
}

export function UpdateAccountRequestToJSON(value?: UpdateAccountRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'employee_name': value.employeeName,
        'profile_image_path': value.profileImagePath,
        'slack_id': value.slackId,
        'phone_number': value.phoneNumber,
    };
}

